<template>
  <div class="wg-bonuses">
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title class="primary white--text wg-bonuses__title">
            Статус участника:
            <span class="wg-bonuses__rating">{{user.rating}}</span>
          </v-card-title>
          <v-card-text
            v-if="user.bonuses"
            class="dashboard__card-text pt-3">
            <v-row class="py-3 wg-bonuses__row">
              <v-col class="wg-bonuses__col" cols="12" sm="6" md="3" v-for="idx in [1,2,3,4]" :key="idx">
                <Bonuses :idx="idx" />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text v-else>
            <p>Список бонусов пуст...</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Bonuses from './Bonuses.vue';

export default {
  components: { Bonuses },
  computed: {
    user() { return this.$store.state.user; },
  },
};
</script>

<style lang="scss">
@use '../../assets/scss/variables';

.wg-bonuses {
  &__rating {
    color: variables.$wb-title-rating-color;
    font-size: .9em;
    padding-left: 10px;
  }
  &__row {
    .wg-bonuses__col {
      padding-left: 6px!important;
      padding-right: 6px!important;
    }
  }
  &__col {
    border-bottom: 1px solid variables.$wb-bonus-border-color;

    &:last-child {
      border: none;
    }

    @media all and (min-width: 600px) and (max-width: 959px) {
      border-right: 1px solid variables.$wb-bonus-border-color;

      &:last-child {
        border: none;
      }

      &:nth-child(2) {
        border-right: none;
      }

      &:nth-child(3) {
        border-bottom: none;
      }
    }

    @media all and (min-width: 960px) {
      border-right: 1px solid variables.$wb-bonus-border-color;
      border-bottom: none;

      &:last-child {
        border: none;
      }
    }
  }
}
</style>
